export const thingsBoardMicroserviceUrl = 'https://telemetry.blinkelectrics.co.ke/iot';